/*jslint       browser: true, continue: true,
 devel: true, indent: 2, maxerr: 50,
 newcap: true, nomen: true, plusplus: true,
 regexp: true, sloppy: true, vars: false,
 white: true
 */
 /*global $: true */

 window.spa.shell = (function () {
    'use strict';
    
    const configMap = {
        resize_interval: 10,
        scroll_interval: 10
    },
    stateMap = {
        anchor_map: {},
        resize_idto: undefined,
        scroll_idto: undefined
    };

    const _calcMainPosition = function() {
        if(window.isEditMode || window.isLoggedIn) {
            $('main').css('top', $('header').outerHeight() - 1 +  + window.spa.util.getGlobals('cocnreteEditPanelHeight')).css('bottom', $('footer').outerHeight());
        } else {
            $('main').css('top', $('header').outerHeight() - 1);//.css('bottom', $('footer').outerHeight());
        }
    };

    //Event Handlers
    const _onResize = function () {
        if (stateMap.resize_idto) {
            return true;
        }

        const event = $.Event('onResize');
        $(window).trigger(event);

        stateMap.resize_idto = setTimeout(
            function () {
                stateMap.resize_idto = undefined;
            },
            configMap.resize_interval
            );

        return true;
    };

    const _onScroll = function () {
        if (stateMap.scroll_idto) {
            return true;
        }

        const event = $.Event('onScroll');
        $(window).trigger(event);

        stateMap.scroll_idto = setTimeout(
            function () {
                stateMap.scroll_idto = undefined;
            },
            configMap.scroll_interval
            );

        return true;
    };

    //Public Methods 
    const configModule = function () {

        return true;
    };

    const initModule = function () {
        $(window)
        .bind('resize', _onResize)
        .bind('scroll', _onScroll);

        $(window).on('resize', _calcMainPosition);
        _calcMainPosition();

        return true;
    };

    return {
        initModule: initModule,
        configModule: configModule
    };
}());